import React from "react";
import { VscClose } from "react-icons/vsc";
import { Row, Col, Card, Image, Alert,Button } from "react-bootstrap";
class _renderVendor extends React.Component {
    render() {
        const { e, idx } = this.props;
        return (<Row className="mb-2">
            <Col>
                <Card bg="uni">
                    <Row className="mt-3 mb-3">
                        <Col className="align-items-center">
                            <Row>
                                <Col xs={2} className="d-flex justify-content-center align-items-center">
                                    <Image src={e.webImgLogo ? e.webImgLogo : this.props._defaultImg} className="img-fluid" width={100} />
                                </Col>
                                <Col xs={9}>
                                    <Col xs={12} className="d-flex justify-content-between align-items-center">
                                        <span><strong>{e.FirmName}</strong></span>
                                        <Button size="sm" variant="light" data-tip="Smazat" onClick={this.props.deleteItm}><VscClose /></Button>
                                    </Col>
                                    <Col xs={12} className="mt-2">
                                        <small>{e.webCardText}</small>
                                    </Col>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>)
    }
}

export default _renderVendor